export const TOCSLIDER = 'TOCSLIDER'